import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const textMessageRoutes: RouteObject[] = [
  {
    path: '/text-message',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Text Messages',
      crumb: () => ({ label: 'Text Messages', to: '/text-message' }),
    },
  },
  {
    path: '/text-messages-status',
    element: lazyElement(() => import('./Status')),
    handle: {
      documentTitle: 'Text Messages Statuses',
      crumb: () => ({ label: 'Text Message Status', to: '/text-messages-status' }),
    },
  },
];

export default textMessageRoutes;
